document.addEventListener('DOMContentLoaded', () => {
  const announcementBarRight = document.querySelector('.announcement-bar__right');
  if (announcementBarRight) {
    announcementBarRight.style.visibility = 'visible';
    announcementBarRight.style.opacity = '0';
    setTimeout(() => {
      announcementBarRight.style.transition = 'opacity 0.8s ease';
      announcementBarRight.style.opacity = '1';
    }, 0);
  }
});
